import { FC } from 'react';
import cx from 'classnames';
import { HeaderSearchBarNoResultsProps } from './types';
import styles from './HeaderSearchBarNoResults.module.scss';

export const HeaderSearchBarNoResults: FC<HeaderSearchBarNoResultsProps> = ({
  message,
  isMobile = false,
}) => (
  <div
    className={cx(styles['header__search-bar-empty'], {
      [styles['header__search-bar-mobile']]: isMobile,
    })}
  >
    {message}
  </div>
);
